module.exports = "/_next/static/images/75df1af6f3e07f97340e1c578a56f889-features-xs.jpg.webp";